module.exports = __webpack_public_path__ + "28b67065/img/pwrd-by-sourcery-black.bba9ba41.svg";